import React from 'react';
import { useMediaQuery } from 'react-responsive';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import BreadCrumbComponent from '@components/obsolete/BreadCrumbComponent/BreadCrumbComponent.tsx';
import Heading from '@components/ringil3/Heading/Heading';
import AiDispatcherActivity from '@components/features/ai-dispatcher/observability/AiDispatcherActivity';

interface ComponentProps {
  /** Set by the admin route, which picks the company from the row it was opened from. */
  companyId?: string;
}

/** What the robot did, is doing and is about to do, for the logged-in user's own company. */
const AiDispatcherActivityPage: React.FC<ComponentProps> = ({ companyId }) => {
  const { tr } = useTranslationLgs();
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  return (
    <>
      {!isMobile && <BreadCrumbComponent items={[{ label: tr('AiDispatcher.activityBreadCrumb', 'AI dispatcher activity') }]} />}
      <Heading title={tr('AiDispatcher.activityPageTitle', 'AI dispatcher activity')} headingVariant="h1" />
      <AiDispatcherActivity companyId={companyId} />
    </>
  );
};

export default AiDispatcherActivityPage;
